import { render, staticRenderFns } from "./popUpTeam.vue?vue&type=template&id=4b6ea824&scoped=true&"
import script from "./popUpTeam.vue?vue&type=script&lang=js&"
export * from "./popUpTeam.vue?vue&type=script&lang=js&"
import style0 from "./popUpTeam.vue?vue&type=style&index=0&id=4b6ea824&prod&lang=scss&scoped=true&"
import style1 from "./popUpTeam.vue?vue&type=style&index=1&id=4b6ea824&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6ea824",
  null
  
)

export default component.exports